import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import { Box, Divider, Grid } from '@mui/material';
import { GridCloseIcon } from '@mui/x-data-grid';

export default function AlertDialog({
    openDialog,
    titleMessage,
    confirmationMessage,
    buttonAgree,
    buttonDisagree,
    handleClose,
    handleSubmit
   
    }) 
    
    {
  return (
    <div>
      <Dialog
        open={openDialog}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title"
         sx={{
          backgroundColor: "#003f93",
          color: "#ffffff",
          fontSize: "16px",
        }}>
          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            <div> {titleMessage}</div>
            <GridCloseIcon
              className="pageHeader"
              onClick={handleClose}
              style={{ cursor: "pointer", color: "white" }}
            />
          </Box>
        </DialogTitle>
        <Divider />
        <Grid container className="bg-white">
          <Grid item xs={12} md={12}>
            <Grid item xs={12} md={12} sx={{ p: 3 }}>
              <Box>{confirmationMessage}</Box>
            </Grid>
            <Divider />
            <React.Fragment>
              <Box
                sx={{display: "flex", flexDirection: "row",alignItems:"flex-end", p: 1.5, pl: 23}}
              >
                 <Box sx={{ flex: "1 1 auto" }} />
                <Button
                  variant="outlined"
                  onClick={handleClose}
                  sx={{ mr: 1}}
                  style={{ marginLeft: "auto" }}
                  autoFocus
                >
                  {buttonDisagree}
                </Button>
                <Button 
                  type="submit"
                  onClick={handleSubmit}
                  sx={{ mr: 1 }}
                  variant="contained"
                  className="button-primary-alt-contained"
                  style={{ marginLeft: "auto" }}
                >
                  {buttonAgree}
                </Button>
               
              </Box>
            </React.Fragment>
          </Grid>
        </Grid>
      </Dialog>
    </div>
  );
}